interface CategoryTabsProps {
  categories: { key: string; name: string }[];
  active: string;
  onChange: (key: string) => void;
  allLabel?: string;
}

export default function CategoryTabs({
  categories,
  active,
  onChange,
  allLabel = "全部",
}: CategoryTabsProps) {
  const items = [{ key: "all", name: allLabel }, ...categories];

  return (
    <div className="w-full overflow-x-auto">
      <div
        role="tablist"
        aria-label="事件分类筛选"
        className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200"
      >
        {items.map((item) => {
          const isActive = active === item.key;
          return (
            <button
              key={item.key}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(item.key)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                isActive
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "text-foreground-600 hover:text-primary-700"
              }`}
            >
              {item.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}